// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Promis10Module-module__font-s-10___cirby {
  font-size: 10px !important;
}

.Promis10Module-module__font-s-12___g6cEE {
  font-size: 12px !important;
}

.Promis10Module-module__font-s-13___iMDdU {
  font-size: 13px !important;
}

.Promis10Module-module__font-s-14___zGqFX {
  font-size: 14px !important;
}

.Promis10Module-module__font-s-15___NidPb {
  font-size: 15px !important;
}

.Promis10Module-module__font-s-16___dSY0g {
  font-size: 16px !important;
}

.Promis10Module-module__font-s-18___Ff7Ag {
  font-size: 18px !important;
}

.Promis10Module-module__font-s-20___e3kK4 {
  font-size: 20px !important;
}

.Promis10Module-module__font-s-22___rI_de {
  font-size: 22px !important;
}

.Promis10Module-module__font-s-28___jgo44 {
  font-size: 28px !important;
}

.Promis10Module-module__font-w-400___B5Jeg {
  font-weight: 400 !important;
}

.Promis10Module-module__font-w-500___b42_K {
  font-weight: 500 !important;
}

.Promis10Module-module__font-w-600___QkMxD {
  font-weight: 600 !important;
}

.Promis10Module-module__font-w-700___AI68h {
  font-weight: 700 !important;
}

.Promis10Module-module__p-5___OtyFD {
  padding: 5px !important;
}

.Promis10Module-module__p-12___sIAoU {
  padding: 12px !important;
}

.Promis10Module-module__p-16___Ky08w {
  padding: 16px !important;
}

.Promis10Module-module__p-30___vTyUp {
  padding: 30px !important;
}

.Promis10Module-module__p-b-0___ybkTv {
  padding-bottom: 0 !important;
}

.Promis10Module-module__p-b-5___p6_2K {
  padding-bottom: 5px !important;
}

.Promis10Module-module__p-b-10___JeB5X {
  padding-bottom: 10px !important;
}

.Promis10Module-module__p-b-12___LJGOE {
  padding-bottom: 12px !important;
}

.Promis10Module-module__p-b-16___SWAvR {
  padding-bottom: 16px !important;
}

.Promis10Module-module__p-b-18___DzvqC {
  padding-bottom: 18px !important;
}

.Promis10Module-module__p-b-20___zvQj7 {
  padding-bottom: 20px !important;
}

.Promis10Module-module__p-b-25___Y9_Zj {
  padding-bottom: 25px !important;
}

.Promis10Module-module__p-b-30___Dk8E5 {
  padding-bottom: 30px !important;
}

.Promis10Module-module__p-b-50___h09j6 {
  padding-bottom: 50px !important;
}

.Promis10Module-module__p-t-0___ph4vn {
  padding-top: 0 !important;
}

.Promis10Module-module__p-t-12___sUJol {
  padding-top: 12px !important;
}

.Promis10Module-module__p-t-16___Ui8sr {
  padding-top: 16px !important;
}

.Promis10Module-module__p-t-18___E50TE {
  padding-top: 18px !important;
}

.Promis10Module-module__p-t-20___LffmV {
  padding-top: 20px !important;
}

.Promis10Module-module__p-t-30___vVAWx {
  padding-top: 30px !important;
}

.Promis10Module-module__p-t-40___xwt9A {
  padding-top: 40px !important;
}

.Promis10Module-module__p-t-50___o6HId {
  padding-top: 50px !important;
}

.Promis10Module-module__p-l-20___LqIqf {
  padding-left: 20px !important;
}

.Promis10Module-module__p-l-30___cBXOq {
  padding-left: 30px !important;
}

.Promis10Module-module__p-l-40___L1WQ3 {
  padding-left: 40px !important;
}

.Promis10Module-module__p-r-16___Rxg5V {
  padding-right: 16px !important;
}

.Promis10Module-module__p-r-20___c3lbG {
  padding-right: 20px !important;
}

.Promis10Module-module__p-r-30___wTmWm {
  padding-right: 30px !important;
}

.Promis10Module-module__p-r-50___a4LJ1 {
  padding-right: 50px !important;
}

.Promis10Module-module__p-r-60___eZo2_ {
  padding-right: 60px !important;
}

.Promis10Module-module__m-b-1___a8rVf {
  margin-bottom: 1px !important;
}

.Promis10Module-module__m-b-2___f4O8J {
  margin-bottom: 2px !important;
}

.Promis10Module-module__m-b-6___HdSl1 {
  margin-bottom: 6px !important;
}

.Promis10Module-module__m-b-8___d04nF {
  margin-bottom: 8px !important;
}

.Promis10Module-module__m-b-10___L3AKT {
  margin-bottom: 10px !important;
}

.Promis10Module-module__m-b-14___efcFw {
  margin-bottom: 14px !important;
}

.Promis10Module-module__m-b-16___WS7S4 {
  margin-bottom: 16px !important;
}

.Promis10Module-module__m-b-20___Xr2c9 {
  margin-bottom: 20px !important;
}

.Promis10Module-module__m-b-22___JPl6i {
  margin-bottom: 22px !important;
}

.Promis10Module-module__m-b-24___vwyC2 {
  margin-bottom: 24px !important;
}

.Promis10Module-module__m-b-30___fCApd {
  margin-bottom: 30px !important;
}

.Promis10Module-module__m-b-32___REY3Q {
  margin-bottom: 32px !important;
}

.Promis10Module-module__m-b-40___hKHZi {
  margin-bottom: 40px !important;
}

.Promis10Module-module__m-t-2___FXpYB {
  margin-top: 2px !important;
}

.Promis10Module-module__m-t-3___tqGrM {
  margin-top: 3px !important;
}

.Promis10Module-module__m-t-4___Z7EB9 {
  margin-top: 4px !important;
}

.Promis10Module-module__m-t-5___jAu2Y {
  margin-top: 5px !important;
}

.Promis10Module-module__m-t-8___jl5BI {
  margin-top: 8px !important;
}

.Promis10Module-module__m-t-10___xcrTt {
  margin-top: 10px !important;
}

.Promis10Module-module__m-t-15___U3JtB {
  margin-top: 15px !important;
}

.Promis10Module-module__m-t-16___uyy2F {
  margin-top: 16px !important;
}

.Promis10Module-module__m-t-20___jtILn {
  margin-top: 20px !important;
}

.Promis10Module-module__m-t-22___G3HIu {
  margin-top: 22px !important;
}

.Promis10Module-module__m-t-30___pUjkL {
  margin-top: 30px !important;
}

.Promis10Module-module__m-t-32___V4D_N {
  margin-top: 32px !important;
}

.Promis10Module-module__m-l-auto___vnNK4 {
  margin-left: auto !important;
}

.Promis10Module-module__m-l-4___qLB0n {
  margin-left: 4px !important;
}

.Promis10Module-module__m-l-5___z1Xm9 {
  margin-left: 5px !important;
}

.Promis10Module-module__m-l-6___DDqr9 {
  margin-left: 6px !important;
}

.Promis10Module-module__m-l-8___b6BQQ {
  margin-left: 8px !important;
}

.Promis10Module-module__m-l-10___s4B4Q {
  margin-left: 10px !important;
}

.Promis10Module-module__m-l-16___C2cLo {
  margin-left: 16px !important;
}

.Promis10Module-module__m-l-20___E0aIp {
  margin-left: 20px !important;
}

.Promis10Module-module__m-l-24___jVoeI {
  margin-left: 24px !important;
}

.Promis10Module-module__m-l-30___tBrm4 {
  margin-left: 30px !important;
}

.Promis10Module-module__m-l-35___FLrPc {
  margin-left: 35px !important;
}

.Promis10Module-module__m-l-40___GMHio {
  margin-left: 40px !important;
}

.Promis10Module-module__m-r-8___Gutfz {
  margin-right: 8px !important;
}

.Promis10Module-module__m-r-10___NXP03 {
  margin-right: 10px !important;
}

.Promis10Module-module__m-r-16___Q58Ur {
  margin-right: 16px !important;
}

.Promis10Module-module__m-r-20___DzZkY {
  margin-right: 20px !important;
}

.Promis10Module-module__m-r-24___QNrEp {
  margin-right: 24px !important;
}

.Promis10Module-module__m-r-30___K7V_v {
  margin-right: 30px !important;
}

.Promis10Module-module__m-r-40___cJymi {
  margin-right: 40px !important;
}

.Promis10Module-module__border-r-3___G2x2D {
  border-radius: 3px !important;
}

.Promis10Module-module__border-r-4___Lzl8O {
  border-radius: 4px !important;
}

.Promis10Module-module__border-r-6___XpeQI {
  border-radius: 6px !important;
}

.Promis10Module-module__border-r-10___kH38f {
  border-radius: 10px !important;
}

.Promis10Module-module__border-r-12___Wvv9N {
  border-radius: 12px !important;
}

.Promis10Module-module__border-r-16___Ndhlg {
  border-radius: 16px !important;
}

.Promis10Module-module__border-r-50___qwziv {
  border-radius: 50% !important;
}

.Promis10Module-module__primary-border___iS38M {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Promis10Module-module__primary-border-b___teZgm {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Promis10Module-module__primary-border-t___tsuOC {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Promis10Module-module__primary-border-l___GCY3a {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Promis10Module-module__primary-border-r___HOCXQ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Promis10Module-module__secondary-border___HhonD {
  border: 1px solid #637768;
}

.Promis10Module-module__secondary-border-b___GLNPY {
  border-bottom: 1px solid #637768;
}

.Promis10Module-module__secondary-border-t____qAJv {
  border-top: 1px solid #637768;
}

.Promis10Module-module__secondary-border-l___j7ey4 {
  border-left: 1px solid #637768;
}

.Promis10Module-module__secondary-border-r___Bleg5 {
  border-right: 1px solid #637768;
}

.Promis10Module-module__gap-0___C3Kxl {
  gap: 0 !important;
}

.Promis10Module-module__gap-2___Q8a6h {
  gap: 2px !important;
}

.Promis10Module-module__gap-4___0fH6P {
  gap: 4px !important;
}

.Promis10Module-module__gap-5___XTz0i {
  gap: 5px !important;
}

.Promis10Module-module__gap-6___TECsy {
  gap: 6px !important;
}

.Promis10Module-module__gap-8___Y0Yco {
  gap: 8px !important;
}

.Promis10Module-module__gap-10___gZSVj {
  gap: 10px !important;
}

.Promis10Module-module__gap-12___F0uml {
  gap: 12px !important;
}

.Promis10Module-module__gap-14___ej0jp {
  gap: 14px !important;
}

.Promis10Module-module__gap-16___O2OqR {
  gap: 16px !important;
}

.Promis10Module-module__gap-18___DJ8Un {
  gap: 18px !important;
}

.Promis10Module-module__gap-20___c9btw {
  gap: 20px !important;
}

.Promis10Module-module__gap-24___nz7zR {
  gap: 24px !important;
}

.Promis10Module-module__gap-26___e1skA {
  gap: 26px !important;
}

.Promis10Module-module__gap-30___KaVuB {
  gap: 30px !important;
}

.Promis10Module-module__gap-32___DfwPW {
  gap: 32px !important;
}

.Promis10Module-module__gap-40___ZRNVT {
  gap: 40px !important;
}

.Promis10Module-module__gap-50___LlVwD {
  gap: 50px !important;
}

.Promis10Module-module__flex-1___dAdoL {
  flex: 1;
}

.Promis10Module-module__flex-none___DUpiT {
  flex: none !important;
}

.Promis10Module-module__flex-column___sJnWN {
  display: flex;
  flex-direction: column !important;
}

.Promis10Module-module__flex-row___suyPu {
  display: flex;
  flex-direction: row !important;
}

.Promis10Module-module__vertically-centered___R0GY7 {
  display: flex;
  align-items: center !important;
}

.Promis10Module-module__horizontally-centered___QGu0T {
  display: flex;
  justify-content: center !important;
}

.Promis10Module-module__horizontally-end___lvF7w {
  display: flex;
  justify-content: end !important;
}

.Promis10Module-module__vertically-start___fw2VP {
  display: flex;
  align-items: start !important;
}

.Promis10Module-module__space-between___b1o9t {
  display: flex;
  justify-content: space-between !important;
}

.Promis10Module-module__flex-wrap___v1rB1 {
  flex-wrap: wrap !important;
}

.Promis10Module-module__height-100___X0BeO {
  height: 100%;
}

.Promis10Module-module__width-50___SCMRQ {
  width: 50% !important;
}

.Promis10Module-module__width-100___GK9eI {
  width: 100%;
}

.Promis10Module-module__cursor-pointer___aoczV {
  cursor: pointer;
}

.Promis10Module-module__cursor-not-allowed___ezztC {
  cursor: not-allowed !important;
}

.Promis10Module-module__absolute-centered___AW4tG {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Promis10Module-module__absolute___Uf_NA {
  position: absolute;
}

.Promis10Module-module__relative___bY9F3 {
  position: relative;
}

.Promis10Module-module__fixed___HLwch {
  position: fixed;
}

.Promis10Module-module__visible___MoOsM {
  opacity: 1;
}

.Promis10Module-module__invisible___qNVV5 {
  opacity: 0;
}

.Promis10Module-module__col-90___dMwVO {
  width: 90% !important;
}

.Promis10Module-module__col-auto___GhmtM {
  width: auto !important;
}

.Promis10Module-module__medical-tabs___Uz3cN {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Promis10Module-module__medical-table-new___lvD2B {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Promis10Module-module__medical-table-new___lvD2B:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Promis10Module-module__medical-table-new___lvD2B::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Promis10Module-module__medical-table-new___lvD2B::-webkit-scrollbar-track {
  display: none;
}
.Promis10Module-module__medical-table-new___lvD2B.Promis10Module-module__no-pagination___rPjy5 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Promis10Module-module__medical-table-new___lvD2B.Promis10Module-module__no-pagination___rPjy5:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Promis10Module-module__medical-table-new___lvD2B.Promis10Module-module__no-pagination___rPjy5::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Promis10Module-module__medical-table-new___lvD2B.Promis10Module-module__no-pagination___rPjy5::-webkit-scrollbar-track {
  display: none;
}

.Promis10Module-module__medical-table-empty___gw0w1 {
  padding: 14px 40px !important;
}

.Promis10Module-module__icon-btn___IRSd_ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Promis10Module-module__search-icon___VhzTY {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Promis10Module-module__disable-select___b4X6t {
  user-select: none;
}

.Promis10Module-module__break-word___ZfJHE {
  word-break: break-word;
}

.Promis10Module-module__popup-clear-btn___s1X4r {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Promis10Module-module__scroll-m-b-20___XPtGg {
  scroll-margin-bottom: 20px;
}

.Promis10Module-module__container___W6DFp {
  color: #375844;
  margin-bottom: -6px;
}
.Promis10Module-module__container___W6DFp .Promis10Module-module__note___rm0px {
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
.Promis10Module-module__container___W6DFp .Promis10Module-module__placeholder___DgFOc {
  color: #637768;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/Promis10Module/Promis10Module.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,yBAAA;EACA,qBAAA;AA8pBJ;AA3pBE;EACE,cAAA;EACA,kBAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  margin-bottom: -6px;\n\n  .note {\n    overflow-wrap: break-word;\n    white-space: pre-wrap;\n  }\n\n  .placeholder {\n    color: get-color(greenNew, medium-dark);\n    font-style: italic;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Promis10Module-module__font-s-10___cirby`,
	"fontS12": `Promis10Module-module__font-s-12___g6cEE`,
	"fontS13": `Promis10Module-module__font-s-13___iMDdU`,
	"fontS14": `Promis10Module-module__font-s-14___zGqFX`,
	"fontS15": `Promis10Module-module__font-s-15___NidPb`,
	"fontS16": `Promis10Module-module__font-s-16___dSY0g`,
	"fontS18": `Promis10Module-module__font-s-18___Ff7Ag`,
	"fontS20": `Promis10Module-module__font-s-20___e3kK4`,
	"fontS22": `Promis10Module-module__font-s-22___rI_de`,
	"fontS28": `Promis10Module-module__font-s-28___jgo44`,
	"fontW400": `Promis10Module-module__font-w-400___B5Jeg`,
	"fontW500": `Promis10Module-module__font-w-500___b42_K`,
	"fontW600": `Promis10Module-module__font-w-600___QkMxD`,
	"fontW700": `Promis10Module-module__font-w-700___AI68h`,
	"p5": `Promis10Module-module__p-5___OtyFD`,
	"p12": `Promis10Module-module__p-12___sIAoU`,
	"p16": `Promis10Module-module__p-16___Ky08w`,
	"p30": `Promis10Module-module__p-30___vTyUp`,
	"pB0": `Promis10Module-module__p-b-0___ybkTv`,
	"pB5": `Promis10Module-module__p-b-5___p6_2K`,
	"pB10": `Promis10Module-module__p-b-10___JeB5X`,
	"pB12": `Promis10Module-module__p-b-12___LJGOE`,
	"pB16": `Promis10Module-module__p-b-16___SWAvR`,
	"pB18": `Promis10Module-module__p-b-18___DzvqC`,
	"pB20": `Promis10Module-module__p-b-20___zvQj7`,
	"pB25": `Promis10Module-module__p-b-25___Y9_Zj`,
	"pB30": `Promis10Module-module__p-b-30___Dk8E5`,
	"pB50": `Promis10Module-module__p-b-50___h09j6`,
	"pT0": `Promis10Module-module__p-t-0___ph4vn`,
	"pT12": `Promis10Module-module__p-t-12___sUJol`,
	"pT16": `Promis10Module-module__p-t-16___Ui8sr`,
	"pT18": `Promis10Module-module__p-t-18___E50TE`,
	"pT20": `Promis10Module-module__p-t-20___LffmV`,
	"pT30": `Promis10Module-module__p-t-30___vVAWx`,
	"pT40": `Promis10Module-module__p-t-40___xwt9A`,
	"pT50": `Promis10Module-module__p-t-50___o6HId`,
	"pL20": `Promis10Module-module__p-l-20___LqIqf`,
	"pL30": `Promis10Module-module__p-l-30___cBXOq`,
	"pL40": `Promis10Module-module__p-l-40___L1WQ3`,
	"pR16": `Promis10Module-module__p-r-16___Rxg5V`,
	"pR20": `Promis10Module-module__p-r-20___c3lbG`,
	"pR30": `Promis10Module-module__p-r-30___wTmWm`,
	"pR50": `Promis10Module-module__p-r-50___a4LJ1`,
	"pR60": `Promis10Module-module__p-r-60___eZo2_`,
	"mB1": `Promis10Module-module__m-b-1___a8rVf`,
	"mB2": `Promis10Module-module__m-b-2___f4O8J`,
	"mB6": `Promis10Module-module__m-b-6___HdSl1`,
	"mB8": `Promis10Module-module__m-b-8___d04nF`,
	"mB10": `Promis10Module-module__m-b-10___L3AKT`,
	"mB14": `Promis10Module-module__m-b-14___efcFw`,
	"mB16": `Promis10Module-module__m-b-16___WS7S4`,
	"mB20": `Promis10Module-module__m-b-20___Xr2c9`,
	"mB22": `Promis10Module-module__m-b-22___JPl6i`,
	"mB24": `Promis10Module-module__m-b-24___vwyC2`,
	"mB30": `Promis10Module-module__m-b-30___fCApd`,
	"mB32": `Promis10Module-module__m-b-32___REY3Q`,
	"mB40": `Promis10Module-module__m-b-40___hKHZi`,
	"mT2": `Promis10Module-module__m-t-2___FXpYB`,
	"mT3": `Promis10Module-module__m-t-3___tqGrM`,
	"mT4": `Promis10Module-module__m-t-4___Z7EB9`,
	"mT5": `Promis10Module-module__m-t-5___jAu2Y`,
	"mT8": `Promis10Module-module__m-t-8___jl5BI`,
	"mT10": `Promis10Module-module__m-t-10___xcrTt`,
	"mT15": `Promis10Module-module__m-t-15___U3JtB`,
	"mT16": `Promis10Module-module__m-t-16___uyy2F`,
	"mT20": `Promis10Module-module__m-t-20___jtILn`,
	"mT22": `Promis10Module-module__m-t-22___G3HIu`,
	"mT30": `Promis10Module-module__m-t-30___pUjkL`,
	"mT32": `Promis10Module-module__m-t-32___V4D_N`,
	"mLAuto": `Promis10Module-module__m-l-auto___vnNK4`,
	"mL4": `Promis10Module-module__m-l-4___qLB0n`,
	"mL5": `Promis10Module-module__m-l-5___z1Xm9`,
	"mL6": `Promis10Module-module__m-l-6___DDqr9`,
	"mL8": `Promis10Module-module__m-l-8___b6BQQ`,
	"mL10": `Promis10Module-module__m-l-10___s4B4Q`,
	"mL16": `Promis10Module-module__m-l-16___C2cLo`,
	"mL20": `Promis10Module-module__m-l-20___E0aIp`,
	"mL24": `Promis10Module-module__m-l-24___jVoeI`,
	"mL30": `Promis10Module-module__m-l-30___tBrm4`,
	"mL35": `Promis10Module-module__m-l-35___FLrPc`,
	"mL40": `Promis10Module-module__m-l-40___GMHio`,
	"mR8": `Promis10Module-module__m-r-8___Gutfz`,
	"mR10": `Promis10Module-module__m-r-10___NXP03`,
	"mR16": `Promis10Module-module__m-r-16___Q58Ur`,
	"mR20": `Promis10Module-module__m-r-20___DzZkY`,
	"mR24": `Promis10Module-module__m-r-24___QNrEp`,
	"mR30": `Promis10Module-module__m-r-30___K7V_v`,
	"mR40": `Promis10Module-module__m-r-40___cJymi`,
	"borderR3": `Promis10Module-module__border-r-3___G2x2D`,
	"borderR4": `Promis10Module-module__border-r-4___Lzl8O`,
	"borderR6": `Promis10Module-module__border-r-6___XpeQI`,
	"borderR10": `Promis10Module-module__border-r-10___kH38f`,
	"borderR12": `Promis10Module-module__border-r-12___Wvv9N`,
	"borderR16": `Promis10Module-module__border-r-16___Ndhlg`,
	"borderR50": `Promis10Module-module__border-r-50___qwziv`,
	"primaryBorder": `Promis10Module-module__primary-border___iS38M`,
	"primaryBorderB": `Promis10Module-module__primary-border-b___teZgm`,
	"primaryBorderT": `Promis10Module-module__primary-border-t___tsuOC`,
	"primaryBorderL": `Promis10Module-module__primary-border-l___GCY3a`,
	"primaryBorderR": `Promis10Module-module__primary-border-r___HOCXQ`,
	"secondaryBorder": `Promis10Module-module__secondary-border___HhonD`,
	"secondaryBorderB": `Promis10Module-module__secondary-border-b___GLNPY`,
	"secondaryBorderT": `Promis10Module-module__secondary-border-t____qAJv`,
	"secondaryBorderL": `Promis10Module-module__secondary-border-l___j7ey4`,
	"secondaryBorderR": `Promis10Module-module__secondary-border-r___Bleg5`,
	"gap0": `Promis10Module-module__gap-0___C3Kxl`,
	"gap2": `Promis10Module-module__gap-2___Q8a6h`,
	"gap4": `Promis10Module-module__gap-4___0fH6P`,
	"gap5": `Promis10Module-module__gap-5___XTz0i`,
	"gap6": `Promis10Module-module__gap-6___TECsy`,
	"gap8": `Promis10Module-module__gap-8___Y0Yco`,
	"gap10": `Promis10Module-module__gap-10___gZSVj`,
	"gap12": `Promis10Module-module__gap-12___F0uml`,
	"gap14": `Promis10Module-module__gap-14___ej0jp`,
	"gap16": `Promis10Module-module__gap-16___O2OqR`,
	"gap18": `Promis10Module-module__gap-18___DJ8Un`,
	"gap20": `Promis10Module-module__gap-20___c9btw`,
	"gap24": `Promis10Module-module__gap-24___nz7zR`,
	"gap26": `Promis10Module-module__gap-26___e1skA`,
	"gap30": `Promis10Module-module__gap-30___KaVuB`,
	"gap32": `Promis10Module-module__gap-32___DfwPW`,
	"gap40": `Promis10Module-module__gap-40___ZRNVT`,
	"gap50": `Promis10Module-module__gap-50___LlVwD`,
	"flex1": `Promis10Module-module__flex-1___dAdoL`,
	"flexNone": `Promis10Module-module__flex-none___DUpiT`,
	"flexColumn": `Promis10Module-module__flex-column___sJnWN`,
	"flexRow": `Promis10Module-module__flex-row___suyPu`,
	"verticallyCentered": `Promis10Module-module__vertically-centered___R0GY7`,
	"horizontallyCentered": `Promis10Module-module__horizontally-centered___QGu0T`,
	"horizontallyEnd": `Promis10Module-module__horizontally-end___lvF7w`,
	"verticallyStart": `Promis10Module-module__vertically-start___fw2VP`,
	"spaceBetween": `Promis10Module-module__space-between___b1o9t`,
	"flexWrap": `Promis10Module-module__flex-wrap___v1rB1`,
	"height100": `Promis10Module-module__height-100___X0BeO`,
	"width50": `Promis10Module-module__width-50___SCMRQ`,
	"width100": `Promis10Module-module__width-100___GK9eI`,
	"cursorPointer": `Promis10Module-module__cursor-pointer___aoczV`,
	"cursorNotAllowed": `Promis10Module-module__cursor-not-allowed___ezztC`,
	"absoluteCentered": `Promis10Module-module__absolute-centered___AW4tG`,
	"absolute": `Promis10Module-module__absolute___Uf_NA`,
	"relative": `Promis10Module-module__relative___bY9F3`,
	"fixed": `Promis10Module-module__fixed___HLwch`,
	"visible": `Promis10Module-module__visible___MoOsM`,
	"invisible": `Promis10Module-module__invisible___qNVV5`,
	"col90": `Promis10Module-module__col-90___dMwVO`,
	"colAuto": `Promis10Module-module__col-auto___GhmtM`,
	"medicalTabs": `Promis10Module-module__medical-tabs___Uz3cN`,
	"medicalTableNew": `Promis10Module-module__medical-table-new___lvD2B`,
	"noPagination": `Promis10Module-module__no-pagination___rPjy5`,
	"medicalTableEmpty": `Promis10Module-module__medical-table-empty___gw0w1`,
	"iconBtn": `Promis10Module-module__icon-btn___IRSd_`,
	"searchIcon": `Promis10Module-module__search-icon___VhzTY`,
	"disableSelect": `Promis10Module-module__disable-select___b4X6t`,
	"breakWord": `Promis10Module-module__break-word___ZfJHE`,
	"popupClearBtn": `Promis10Module-module__popup-clear-btn___s1X4r`,
	"scrollMB20": `Promis10Module-module__scroll-m-b-20___XPtGg`,
	"container": `Promis10Module-module__container___W6DFp`,
	"note": `Promis10Module-module__note___rm0px`,
	"placeholder": `Promis10Module-module__placeholder___DgFOc`
};
module.exports = ___CSS_LOADER_EXPORT___;
